import {
  Checkbox,
  FontColorEnum,
  FontSizeEnum,
  FontWeightEnum,
  HTMLElementTypeEnum,
  Switch,
  SwitchColorEnum,
  Typography,
} from '@acceso/design-system';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';
import { SegmentsCardBulkActions } from '@/features/segments/components/SegmentsCardBulkActions';
import { TSegment } from '@/features/segments/types';
import { useSelectedItemsStore } from '@/stores/selected-items';

import { BroadcastScheduleProgramBodySegmentCardBulkActions } from './BroadcastScheduleProgramBodySegmentCardBulkActions';

type TTracingListHeaderResult = {
  items: TSegment[];
  segments?: boolean;
  total?: number;
  className?: string;
};
export function BroadcastScheduleProgramBodySegmentCardHeader({
  items,
  segments,
  total,
  className,
}: TTracingListHeaderResult) {
  const { t } = useTranslation();
  const store = useSelectedItemsStore();
  const { compactUis, setCompactUis } = useBroadcastScheduleProgram();

  const handleCheckboxChange = () => {
    if (store.toggleAllActived) {
      store.dispatch({ type: 'removeToggleAll' });
      store.dispatch({ type: 'resetIds' });
    } else {
      store.dispatch({
        type: 'toggleAll',
      });
      store.dispatch({
        type: 'include',
        payload: items.map(item => item.id),
      });
    }
  };

  return (
    <div
      className={clsx(
        'sticky top-0 z-10 flex min-w-[120px] items-center justify-between gap-4 bg-white py-2',
        className
      )}
    >
      <div className="flex items-center gap-2">
        <Checkbox
          onChange={handleCheckboxChange}
          indeterminate={
            store.include.length > 0 &&
            store.include.length < items.length &&
            !store.toggleAllActived
          }
          checked={
            store.toggleAllActived ||
            (store.include.length === items.length && store.include.length > 0 && items.length > 0)
          }
          disabled={items?.length === 0}
        >
          {items.length === 0 ? (
            <Typography
              fontSize={FontSizeEnum.Basic}
              weight={FontWeightEnum.Regular}
              color={FontColorEnum.Dark10}
            >
              {t('Sin resultados')}
            </Typography>
          ) : items.length === 1 ? (
            <>
              <Typography
                fontSize={FontSizeEnum.Basic}
                weight={FontWeightEnum.Regular}
                color={FontColorEnum.Dark10}
              >
                {t('1 Resultado')}
              </Typography>
            </>
          ) : (
            <>
              <Typography
                fontSize={FontSizeEnum.Basic}
                weight={FontWeightEnum.Semibold}
                color={FontColorEnum.Dark10}
              >
                {store.toggleAllActived
                  ? `${items?.length} / `
                  : store.include.length !== 0 && `${store.include.length} / `}
              </Typography>
              {items?.length < 10000 ? (
                <>
                  <Typography
                    element={HTMLElementTypeEnum.Span}
                    fontSize={FontSizeEnum.Basic}
                    weight={FontWeightEnum.Bold}
                    color={FontColorEnum.Dark10}
                  >
                    {total ? items?.length + ' / ' + total : items?.length}
                  </Typography>
                  <Typography
                    element={HTMLElementTypeEnum.Span}
                    fontSize={FontSizeEnum.Basic}
                    weight={FontWeightEnum.Regular}
                    color={FontColorEnum.Dark10}
                  >
                    {' '}
                    {t('Resultados')}
                  </Typography>
                </>
              ) : (
                <Typography
                  fontSize={FontSizeEnum.Basic}
                  weight={FontWeightEnum.Regular}
                  color={FontColorEnum.Dark10}
                >
                  10.000+
                </Typography>
              )}
            </>
          )}
        </Checkbox>

        {segments ? (
          <BroadcastScheduleProgramBodySegmentCardBulkActions />
        ) : (
          <SegmentsCardBulkActions />
        )}
      </div>

      {items && items.length > 0 && (
        <Switch
          checked={compactUis}
          onChange={() => setCompactUis(prev => !prev)}
          endLabel="Compact"
          color={SwitchColorEnum.SUCCESS}
        />
      )}
    </div>
  );
}
